import { SvgIconProps } from '@traba/types'

export default function BarGraphTriple({
  size = 24,
  fillColor,
  ...rest
}: SvgIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" {...rest}>
      <rect x="0.5" y="10" width="4" height="4" rx="1" fill={fillColor} />
      <rect x="6" y="6" width="4" height="8" rx="1" fill={fillColor} />
      <rect x="11.5" y="2" width="4" height="12" rx="1" fill={fillColor} />
    </svg>
  )
}
